import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {ExamProfessionalSelectionNotFoundState} from './components/ExamProfessionalSelectionNotFoundState';

import {ExamNearestDateProfessionalList} from './components/ExamNearestDateProfessionalList';
import {ExamSelectedDateProfessionalList} from './components/ExamSelectedDateProfessionalList';

import {ExamProfessionalSelectionProps} from './types';
import {useExamProfessionalSelection} from './hooks/useExamProfessionalSelection';

const {bookExams} = translations['pt-br'].privateFlow.services;
const {loadingState, loadingError} = translations['pt-br'].privateFlow.bookingFlow.professionalFlow;

export function ExamProfessionalSelection({handleNextStep}: ExamProfessionalSelectionProps) {
	const {
		isLoading,
		isError,
		refetch,
		showNotFoundState,
		showSelectedDateProfessionalGrid,
		examsAvailableTimesFiltered,
		examsMultiAvailableTimesFiltered,
		showClearFilterButton,
		selectedDate,
		handleSelectHour,
		handleClearShiftAndSearch,
		notFoundStateDataTagId,
		query,
	} = useExamProfessionalSelection({handleNextStep});

	if (isLoading) {
		return (
			<BookingLoadingState
				showHeader={false}
				pageTitle={bookExams}
				loadingText={loadingState}
			/>
		);
	}

	if (isError) {
		return (
			<BookingErrorState
				showHeader={false}
				pageTitle={bookExams}
				errorTitle={loadingError}
				handleRefresh={refetch}
			/>
		);
	}

	if (showNotFoundState) {
		return (
			<ExamProfessionalSelectionNotFoundState
				showClearFilterButton={showClearFilterButton}
				handleClearShiftAndSearch={handleClearShiftAndSearch}
				dataTagId={notFoundStateDataTagId()}
			/>
		);
	}

	return (
		<Fragment>
			{showSelectedDateProfessionalGrid ? (
				<ExamSelectedDateProfessionalList
					list={examsAvailableTimesFiltered}
					handleSelectHour={handleSelectHour}
					date={selectedDate}
					query={query}
				/>
			) : (
				<ExamNearestDateProfessionalList
					list={examsMultiAvailableTimesFiltered}
					handleSelectHour={handleSelectHour}
					query={query}
				/>
			)}
		</Fragment>
	);
}
